module.exports = __webpack_public_path__ + "static/favicon-a963e8bc2ae10586c37bbe29a6a041af.png";